module.exports = __webpack_public_path__ + "img/left-lightning11.e6931b55.png";